import { AgentConfigOptions } from '@elastic/apm-rum';
import { config } from './reolink';
import { version } from '../../package.json';

// APM Transaction Names (using E-code format)
export enum EApmTransactionName {
    LEVEL1_ORDER_PREVIEW = 'LEVEL1_ORDER_PREVIEW',
    LEVEL1_ORDER_CREATE = 'LEVEL1_ORDER_CREATE',
    LEVEL1_COUPON_APPLY = 'LEVEL1_COUPON_APPLY',
    LEVEL1_AI_SEARCH = 'LEVEL1_AI_SEARCH',
    LEVEL1_DOWNLOAD_VIDEO = 'LEVEL1_DOWNLOAD_VIDEO',
    LEVEL1_DELETE_VIDEO = 'LEVEL1_DELETE_VIDEO',
    LEVEL1_ENTER_PIN_CONFIRM = 'LEVEL1_ENTER_PIN_CONFIRM',
    LEVEL1_LIBRARY_FILTER = 'LEVEL1_LIBRARY_FILTER',
    LEVEL1_ORDER_PAY_PAYONEER = 'LEVEL1_ORDER_PAY_PAYONEER',
    LEVEL1_ORDER_PAY_PAYPAL = 'LEVEL1_ORDER_PAY_PAYPAL',
    LEVEL1_ORDER_PAY_ADYEN = 'LEVEL1_ORDER_PAY_ADYEN',
    LEVEL1_AUTO_RENEW_ENABLE = 'LEVEL1_AUTO_RENEW_ENABLE',
    LEVEL1_AUTO_RENEW_DISABLE = 'LEVEL1_AUTO_RENEW_DISABLE',
    LEVEL2_OTHER_VIDEO = 'LEVEL2_OTHER_VIDEO',
    LEVEL2_TABBOX_LEFT_TAB = 'LEVEL2_TABBOX_LEFT_TAB',
    LEVEL2_TABBOX_RIGHT_TAB = 'LEVEL2_TABBOX_RIGHT_TAB',
}

// APM Transaction Types
export enum EApmTransactionType {
    USER_INTERACTION = 'user-interaction',
    PAYMENT_PROCESS = 'payment-process',
}

// APM Span Names (using E-code format)
export enum EApmSpanName {
    LEVEL1_EXAMPLE_SPAN = 'LEVEL1_EXAMPLE_SPAN',
}

// APM Span Types
export enum EApmSpanType {
    USER_ACTION = 'user-action',
}

// APM RUM 配置
export const apmConfig: AgentConfigOptions = {
    serviceName: 'reolink-cloud',
    serverUrl: import.meta.env.VITE_APM_SERVER_URL,
    serviceVersion: version, // 可以从 package.json 动态读取
    environment: config.envFlag,
    
    // 性能监控配置
    active: true,
    
    // 分布式追踪
    distributedTracing: true,

    instrument: true,
    serverUrlPrefix: '/v2/shop/ru',
    disableInstrumentations: config.isProduction ? ['error'] : [],
};

/**
 * APM Monitor Configuration for logging and transaction management
 */
export interface ApmMonitorConfig {
    /**
     * Maximum number of global logs to retain across transactions
     * These provide context across the entire session
     * @default 100
     */
    maxGlobalLogs: number;
    
    /**
     * Maximum number of transaction-specific logs
     * These are cleared when a new transaction starts
     * @default 50
     */
    maxTransactionLogs: number;
    
    /**
     * Transaction timeout in milliseconds
     * Automatically ends transactions that exceed this duration
     * Set to 0 to disable timeout
     * @default 300000 (5 minutes)
     */
    transactionTimeoutMs: number;
    
    /**
     * Whether to include global logs in transaction context
     * @default true
     */
    includeGlobalLogsInTransaction: boolean;
}

export const apmMonitorConfig: ApmMonitorConfig = {
    maxGlobalLogs: 100,
    maxTransactionLogs: 50,
    transactionTimeoutMs: 5 * 60 * 1000, // 5 minutes
    includeGlobalLogsInTransaction: true
};
